import { render, staticRenderFns } from "./shopping copy.vue?vue&type=template&id=48ab0e4a&scoped=true"
import script from "./shopping copy.vue?vue&type=script&lang=js"
export * from "./shopping copy.vue?vue&type=script&lang=js"
import style0 from "./shopping copy.vue?vue&type=style&index=0&id=48ab0e4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ab0e4a",
  null
  
)

export default component.exports